<template>
	<svg width="44" height="44" viewBox="0 0 44 44" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
		<path d="M28.567 10.6256L35.134 22L28.567 33.3744L15.433 33.3744L8.86603 22L15.433 10.6256L28.567 10.6256Z" fill="#E5F6FD" stroke="#0074B5" stroke-width="1.5"/>
	</svg>
</template>
